export const CUSTOMERS = [
    {
        id: 0,
        name:"Accounting",
        image: "/assets/images/fin6.jpeg",
        featured: true,
        description:"MBAV seeks to provide a full suite of Accounting, Auditing, valuation and business consultancy, training services for small businesses in A.A, Ethiopia, allowing business owners to not only save money over in-house accounting and ensure their compliance with tax laws, but to make valuable management decisions from their numbers."
    },
    {
        id: 1,
        name: "Tax Preparation",
        image: "/assets/images/fin2.jpeg",
        featured: false,
        description: "Tax Preparation Service. We have 10 Years of personal & business income tax preparation, sales tax preparation.  Preparing your tax return can be a quite difficult task that leaves you with more questions than answers."
    },
    {
        id: 2,
        name: "Book Keeping and Payroll",
        image: "/assets/images/fin1.jpeg",
        featured: false,
        description: "Bookkeeping & Payroll. Our Bookkeeping and Payroll services are designed to meet the needs of your business and are available to all small and large companies. We understand how overwhelming the payroll can be for your business owner when there are many other vital issues."
    },
    {
        id: 3,
        name: "company Formation",
        image: "/assets/images/fin5.jpeg",
        featured: false,
        description: "Company Formation. Opening your own business is exciting and exciting. It’s all that comes after the excitement and excitement that fades, which determines whether a small business will succeed or not. It’s up to you to maintain and extend the chills and excitement period forever."
    }
]